import { Hidden } from '@mui/material';
import { UnpyEvent } from 'domain/event/UnpyEvent';
import { UnpyEventView } from 'domain/event/UnpyEventView';
import { Team } from 'domain/team/Team';
import { TeamMembersViewDatatable } from 'primary/teams/TeamMembersViewDatatable';
import { TeamMembersViewMobile } from 'primary/teams/TeamMembersViewMobile';
import React from 'react';

export interface TeamsViewDatatableParametersProps {
  reFetch: () => void;
  onDecline: () => void;
  team: Team;
  event?: UnpyEvent | UnpyEventView;
  disabled?: boolean;
}

export const ResponsiveTeamMembersView = (props: TeamsViewDatatableParametersProps) => {
  return (
    <>
      <Hidden smDown>
        <TeamMembersViewDatatable {...props} />
      </Hidden>
      <Hidden smUp>
        <TeamMembersViewMobile {...props} />
      </Hidden>
    </>
  );
};
